import { TENANT_AUTH_STORAGE_KEY } from "../helpers/api_helper";

export type TenantRole = "owner" | "editor" | "approver";

export function getTenantRoles(): TenantRole[] {
  try {
    const raw = sessionStorage.getItem(TENANT_AUTH_STORAGE_KEY);
    const roles = raw ? JSON.parse(raw)?.user?.roles : [];
    return Array.isArray(roles)
      ? roles.filter((role): role is TenantRole =>
          ["owner", "editor", "approver"].includes(role)
        )
      : [];
  } catch {
    return [];
  }
}

export const hasTenantRole = (...roles: TenantRole[]): boolean =>
  getTenantRoles().some((role) => roles.includes(role));

export const isOwner = (): boolean => hasTenantRole("owner");

export const canApproveSend = (): boolean =>
  hasTenantRole("owner", "approver");

export const canManageBilling = (): boolean => isOwner();
